module.exports = __webpack_public_path__ + "static/media/COMMENT_WHITE.e94ff639.svg";